import React, { Component } from 'react';
import PropTypes from "prop-types";
import "./WebNetOptions.css";

import ItemSelect from "./WebNetSelect";
//import { Button } from "@blueprintjs/core";


import { withTranslation } from 'react-i18next';

class WebNetOptios extends Component {
    
    constructor(props) {
        super(props);
        this.state = { 
            loading: true, 
            alertMessageViewer:"",
        };
    }

    render() {
        const {
 
            animalNameList,
            selectedAnimalName,        
            handleAnimalSelectByName,
            ownersNameList,
            selectedOwnerName,
            handleOwnerSelectByName,
            t
        } = this.props;

        //console.log(animalNameList);
        //console.log(ownersNameList);


        return (
            <div className="options"> 
                       <div className="searchs">  
                    <ItemSelect items={ownersNameList || []} selectedItem={selectedOwnerName || t("(No owner selected)")} onSelect={(owner, pos) => handleOwnerSelectByName(owner, pos)} widthX={300}  heightY = {30}  label="" />
                    <ItemSelect items={animalNameList || []} selectedItem={selectedAnimalName || t("(No animal selected)")} onSelect={(animal, pos) => handleAnimalSelectByName(animal, pos)} widthX={300}  heightY = {30}  label=""/>
                    
                                                          
                       </div>           
            </div>
        );
    }
}

export default withTranslation()(WebNetOptios);

WebNetOptios.propTypes = {
    animalNameList: PropTypes.array.isRequired,
    ownersNameList: PropTypes.array.isRequired, 
    selectedAnimalName: PropTypes.string.isRequired,
    selectedOwnerName: PropTypes.string.isRequired,
    handleAnimalSelectByName: PropTypes.func.isRequired,
    handleOwnerSelectByName: PropTypes.func.isRequired,
};
